import FormControl from "@mui/material/FormControl";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";

import { formControlSelectSx } from "../../utils/helper";
import { Box, Chip, IconButton, InputAdornment } from "@mui/material";
import ClearIcon from '@mui/icons-material/Clear';


const Dropdown = ({
  className,
  name,
  label,
  placeholder,
  error,
  value,
  onChange,
  options,
  touched,
  multiple = false,
  allowBlankValue = true,
  sx = {},
  parentSx = {},
  onBlur = () => { },
  selectSx = {},
  endAdornment = <></>,
  showLegend = false,
  showErrorText = true,
  disabled = false,
  clearable = false,
  handleClear = () => { },
}) => {

  const addOnSelectProps = {}

  if (multiple) {
    addOnSelectProps.renderValue = (selected) => (
      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
        {selected.map((value) => (
          <Chip key={value} label={value}
            style={{
              height: '22px'
            }}
          />
        ))}
      </Box>
    )
  }

  if (clearable && handleClear) {
    addOnSelectProps.endAdornment = <>
      {
        value && (
          <InputAdornment position="end">
            <IconButton onClick={handleClear} edge="end">
              <ClearIcon />
            </IconButton>
          </InputAdornment>
        )
      }
    </>
  }



  return (
    <Box component="span" sx={{ ...parentSx }} className={className ?? ''}>
      <FormControl
        className={`w-full`} size="small" variant="outlined"
        error={Boolean(error)}
        sx={{ ...sx, ...formControlSelectSx, '& legend': { display: showLegend ? 'inherit' : 'none' } }}
        hiddenLabel={true}
        disabled={disabled}
      >
        <Select
          name={name}
          multiple={multiple}
          className='font-semibold'
          labelId="demo-simple-select-label"
          id="named-select"
          label={label}
          placeholder={placeholder ?? ''}
          error={Boolean(error && touched)}
          value={value}
          onBlur={onBlur}
          onClose={onBlur}
          onChange={onChange}
          endAdornment={endAdornment}
          inputProps={{
            '::placeholder': {
              color: 'red'
            }
          }}
          sx={{
            ...selectSx
          }}
          {...addOnSelectProps}
        >
          {allowBlankValue && <MenuItem value="">
            <em>--select--</em>
          </MenuItem>}
          {
            options.map((item, index) => {
              return <MenuItem key={index} value={item}
                sx={{
                  fontFamily: '"Quicksand", sans-serif',
                  fontWeight: 500
                }}
              >{item}</MenuItem >
            })
          }
        </Select>
        {touched && error && showErrorText ? (
          <span className="font-semibold text-red-700 text-xs mt-2">
            {error}
          </span>
        ) : null}
      </FormControl>
    </Box>
  );
}

export default Dropdown;